import MegaMenu from './megaMenu';
import SearchForm from './searchForm';
import UtilityDropdown from './utilityDropdown';

// Attach to window object
window.MegaMenu = MegaMenu;
window.SearchForm = SearchForm;
window.UtilityDropdown = UtilityDropdown;